import React from "react"
import { ActionIcon, RemoveButton, area, field, label, link } from "./styles"

const t = key => I18n.t(`automations.webhook_fields.${key}`)

const Text = ({ name, value, update, type = "text", className = "", saved = false }) => (
  <input type={type} className={`${field} ${className}`} value={value} autoComplete={type === "password" ? "new-password" : undefined}
         placeholder={saved ? t("secret_kept") : undefined} onChange={e => update({ [name]: e.target.value })} />
)

const WebhookCard = ({ webhook, type, manual, props, update, remove }) => {
  const headers = webhook.customHeaders
  const setHeader = (index, change) => update({ customHeaders: headers.map((h, i) => (i === index ? { ...h, ...change } : h)) })

  return (
    <div className="!mt-3 rounded-xl border border-slate-200 bg-white">
      <div className="flex items-center gap-3 border-b border-slate-100 !px-3.5 !py-2.5">
        <ActionIcon type={type} />
        <span className="flex-1 text-[13px] font-semibold text-slate-800">{type.label}</span>
        <RemoveButton onClick={remove} />
      </div>

      <div className="space-y-3 !p-3.5">
        <div className="grid gap-3 sm:grid-cols-[110px_minmax(0,1fr)]">
          <div>
            <span className={label}>{t("http_method")}</span>
            <select className={field} value={webhook.httpMethod} onChange={e => update({ httpMethod: e.target.value })}>
              {props.httpMethods.map(method => <option key={method} value={method}>{method}</option>)}
            </select>
          </div>
          <div>
            <span className={label}>{t("url")}</span>
            <input type="text" className={`${field} font-mono`} value={webhook.url} placeholder="https://…"
                   onChange={e => update({ url: e.target.value })} />
          </div>
        </div>

        <div>
          <span className={label}>{t("authentication_method")}</span>
          <select className={field} value={webhook.authenticationMethod} onChange={e => update({ authenticationMethod: e.target.value })}>
            {props.authMethods.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        {webhook.authenticationMethod === "AUTHENTICATION_METHOD_BASIC" && (
          <div className="grid gap-3 sm:grid-cols-2">
            <div><span className={label}>{t("basic_user")}</span><Text name="basicUser" value={webhook.basicUser} update={update} /></div>
            <div><span className={label}>{t("basic_password")}</span><Text name="basicPassword" type="password" value={webhook.basicPassword} saved={webhook.savedSecrets.basicPassword} update={update} /></div>
          </div>
        )}
        {webhook.authenticationMethod === "AUTHENTICATION_METHOD_BEARER" && (
          <div><span className={label}>{t("bearer_token")}</span><Text name="bearerToken" type="password" value={webhook.bearerToken} saved={webhook.savedSecrets.bearerToken} update={update} /></div>
        )}
        {webhook.authenticationMethod === "AUTHENTICATION_METHOD_OAUTH" && (
          <div className="grid gap-3 sm:grid-cols-3">
            <div><span className={label}>{t("oauth_url")}</span><Text name="oauthUrl" value={webhook.oauthUrl} update={update} /></div>
            <div><span className={label}>{t("oauth_client")}</span><Text name="oauthClient" value={webhook.oauthClient} update={update} /></div>
            <div><span className={label}>{t("oauth_secret")}</span><Text name="oauthSecret" type="password" value={webhook.oauthSecret} saved={webhook.savedSecrets.oauthSecret} update={update} /></div>
          </div>
        )}

        <div>
          <span className={label}>{t("custom_headers")}</span>
          <div className="space-y-2">
            {headers.map((header, index) => (
              <div key={index} className="flex items-center gap-2">
                <input type="text" className={`${field} h-9 font-mono`} value={header.name} placeholder="X-Header"
                       onChange={e => setHeader(index, { name: e.target.value })} />
                <input type="text" className={`${field} h-9 font-mono`} value={header.value}
                       onChange={e => setHeader(index, { value: e.target.value })} />
                <RemoveButton icon="fa-times" onClick={() => update({ customHeaders: headers.filter((_, i) => i !== index) })} />
              </div>
            ))}
          </div>
          <button type="button" className={`!mt-2 ${link}`} onClick={() => update({ customHeaders: [...headers, { name: "", value: "" }] })}>
            <i className="fas fa-plus text-[10px]" />{t("add_header")}
          </button>
        </div>

        <div>
          <span className={label}>{t("payload_template")}</span>
          <textarea rows={4} className={`${area} font-mono text-[12px]`} value={webhook.payloadTemplate}
                    placeholder={'{ "id": "{{ workorder.id }}" }'} onChange={e => update({ payloadTemplate: e.target.value })} />
          <p className="!mt-1 text-[11px] text-slate-400">{t("payload_hint")}</p>
        </div>

        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <label className="inline-flex cursor-pointer items-center gap-2 text-[12.5px] text-slate-600">
            <input type="checkbox" className="h-4 w-4 accent-blue-600" checked={webhook.filterable}
                   onChange={e => update({ filterable: e.target.checked })} /> {t("filterable")}
          </label>
          {manual && (
            <label className="inline-flex cursor-pointer items-center gap-2 text-[12.5px] text-slate-600">
              <input type="checkbox" className="h-4 w-4 accent-blue-600" checked={webhook.isRedirection}
                     onChange={e => update({ isRedirection: e.target.checked })} /> {t("is_redirection")}
            </label>
          )}
        </div>
      </div>
    </div>
  )
}

export default WebhookCard
